import { registerPlugin } from '@capacitor/core';

export interface DirectSharePlugin {
    pushContacts(options: { contacts: Array<{ id: string; name: string; type: string }> }): Promise<void>;
}

const DirectShare = registerPlugin<DirectSharePlugin>('DirectShare');

export default DirectShare;
